import React, { useCallback } from 'react';
import { Tappable } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  editSbatGroupInterviewbitTestsSelector,
  editSbatGroupSelectedInterviewbitTestSelector,
  setEditSbatGroupSelectedInterviewbitTest,
} from 'features/classCreation';
import styles from './InterviewbitTestSelect.module.scss';

function InterviewbitTestSelect() {
  const dispatch = useDispatch();
  const interviewbitTests = useSelector(editSbatGroupInterviewbitTestsSelector);
  const selectedInterviewbitTest = useSelector(
    editSbatGroupSelectedInterviewbitTestSelector
  );

  const handleOnClick = useCallback(
    (interviewbitTest) => {
      dispatch(setEditSbatGroupSelectedInterviewbitTest(interviewbitTest));
    },
    [dispatch]
  );

  return interviewbitTests.map((interviewbitTest) => (
    <Tappable
      key={interviewbitTest.test_id}
      className={classNames(styles.tappable, {
        [styles.selected]:
          selectedInterviewbitTest?.test_id === interviewbitTest.test_id,
      })}
      onClick={() => handleOnClick(interviewbitTest)}
    >
      {interviewbitTest.title}
    </Tappable>
  ));
}

export default InterviewbitTestSelect;
